import { z } from 'zod'

import SelectBase from '@/components/Form/Atoms/SelectBase/SelectBase'
import { ProductType } from '@/types/product'
import FormResolverUtils from '@/utils/FormResolverUtils'

const formResolverUtils = FormResolverUtils({ schema: z.string(), i18nName: 'バリエーション' })

export const productVariationDefaultValue = (products: ProductType[]) => products[0].productId

const options = (products: ProductType[]) =>
  products.map((product) => {
    return {
      label: `¥${product.invoiceItem.totalListPriceWithTax.toLocaleString()}${
        product.capacity != null ? ` / ${product.capacity}` : ''
      }`,
      value: product.productId,
    }
  })

export const productVariationScheme = (products: ProductType[]) => {
  return {
    [productVariationInputKey]: formResolverUtils.enum(
      Object.fromEntries(products.map((product) => [product.productId, product.productId]))
    ).schema,
  }
}

export const productVariationInputKey = 'productVariation'

const ProductVariationInput = ({ products }: { products: ProductType[] }) => {
  return <SelectBase name={productVariationInputKey} options={options(products)} />
}

export default ProductVariationInput
